<mat-toolbar matDialogTitle class="mat-accent m-0">
  <span class="title dialog-title">{{ header | translate }}</span>
  <button mat-button class="mat-icon-button"
          (click)="dialogRef.close()"
          aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="content">
  @switch (type) {
    @case ('banner') {
      <ng-container *ngTemplateOutlet="banner"></ng-container>
    }
    @case ('news') {
      <ng-container *ngTemplateOutlet="news"></ng-container>
    }
    @case ('systemText') {
      <ng-container *ngTemplateOutlet="systemText"></ng-container>
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button class="mat-accent" [disabled]="disableSave()"
          (click)="onSaveClick()">{{ 'main.save' | translate }}
  </button>
  <button mat-raised-button class="mat-accent" (click)="onNoClick()">{{ 'main.cancel' | translate }}</button>
</mat-dialog-actions>


<ng-template #banner>
  <div class="banner-form">
    <mat-form-field class="full-width">
      <mat-label>{{ 'forumTalk.text' | translate }}</mat-label>
      <textarea matInput cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="5" [formField]="bannerForm.text"></textarea>
      @if (bannerForm.text().invalid() && bannerForm.text().touched()) {
        <mat-error>
          @for (error of bannerForm.text().errors(); track error) {
            {{ error.message | translate }}
          }
        </mat-error>
      }
    </mat-form-field>
    <mat-checkbox [formField]="bannerForm.active" class="full-width">
      {{ 'forumTalk.active' | translate }}
    </mat-checkbox>
    <mat-form-field class="half-width">
      <mat-label>{{ 'forumTalk.date_from' | translate }}</mat-label>
      <input matInput [matDatepicker]="dateFrom"
             [formField]="bannerForm.dateFrom" [min]="minDate">
      @if (bannerForm.dateFrom().value()) {
        <mat-icon (click)="cleanDateField('dateFrom')" class="clean-icon">clear</mat-icon>
      }
      <mat-datepicker #dateFrom/>
      <mat-datepicker-toggle [for]="dateFrom" matSuffix/>
    </mat-form-field>
    <mat-form-field class="half-width">
      <mat-label>{{ 'forumTalk.time_from' | translate }}</mat-label>
      <input matInput
             [formField]="bannerForm.dateFrom"
             [matTimepicker]="dateFromTimePicker">
      <mat-timepicker #dateFromTimePicker/>
      <mat-timepicker-toggle [for]="dateFromTimePicker" matSuffix/>
    </mat-form-field>

    <mat-form-field class="half-width">
      <mat-label>{{ 'forumTalk.date_to' | translate }}</mat-label>
      <input matInput [matDatepicker]="dateTo"
             [formField]="bannerForm.dateTo" [min]="minDate">
      @if (bannerForm.dateTo().value()) {
        <mat-icon (click)="cleanDateField('dateTo')" class="clean-icon">clear</mat-icon>
      }
      <mat-datepicker #dateTo/>
      <mat-datepicker-toggle [for]="dateTo" matSuffix/>
    </mat-form-field>
    <mat-form-field class="half-width">
      <mat-label>{{ 'forumTalk.time_to' | translate }}</mat-label>
      <input matInput
             [formField]="bannerForm.dateTo"
             [matTimepicker]="dateToTimePicker">
      <mat-timepicker #dateToTimePicker/>
      <mat-timepicker-toggle [for]="dateToTimePicker" matSuffix/>
    </mat-form-field>
  </div>
</ng-template>


<ng-template #news>
  <div class="news-form">
    <div class="quill-description">
      <div class="quill-title">{{ 'forumTalk.text' | translate }}</div>
      <quill-editor [ngModel]="newsText" [modules]="{ toolbar: quillConfig }"
                    (onContentChanged)="onDescriptionChange($event)"></quill-editor>
    </div>
    <mat-form-field class="full-width">
      <mat-label>{{ 'forumTalk.date' | translate }}</mat-label>
      <input matInput [matDatepicker]="date"
             [formField]="newsForm.date" [min]="minDate">
      <mat-datepicker #date/>
      <mat-datepicker-toggle [for]="date" matSuffix/>
      @if (newsForm.date().invalid() && newsForm.date().touched()) {
        <mat-error>
          @for (error of newsForm.date().errors(); track error) {
            {{ error.message | translate }}
          }
        </mat-error>
      }
    </mat-form-field>
  </div>
</ng-template>


<ng-template #systemText>
  <div class="system-text-form">
    <mat-form-field class="full-width">
      <mat-label>{{ 'forumTalk.title' | translate }}</mat-label>
      <input matInput [formField]="systemTextForm.type"
             placeholder="{{ 'forumTalk.system_text_title_description' | translate }}">
      @if (systemTextForm.type().invalid() && systemTextForm.type().touched()) {
        <mat-error>
          @for (error of systemTextForm.type().errors(); track error) {
            {{ error.message | translate }}
          }
        </mat-error>
      }
    </mat-form-field>
    <div class="quill-description">
      <div class="quill-title">{{ 'forumTalk.text' | translate }}</div>
      <quill-editor [ngModel]="systemTextData" [modules]="{ toolbar: quillConfig }"
                    (onContentChanged)="onSystemTextChange($event)"></quill-editor>
    </div>
  </div>
</ng-template>
